/** Khối lõi — dùng cho mọi môn: văn bản, hình ảnh, đọc thêm, trắc nghiệm nhanh, thẻ từ. */
import { useState } from "react";
import { Alert, Card, Flex, Image, Radio, Space, Tag, Typography } from "antd";

import { MarkdownContent } from "@/components/MarkdownContent";

import { HAN_FONT } from "../shared";
import { AudioButton, WordLine } from "../ui";
import type {
  BlockProps,
  DocBlock,
  HinhAnhBlock,
  TheTuBlock,
  TracNghiemBlock,
  VanBanBlock,
} from "../types";

const { Paragraph, Text } = Typography;

export function VanBan({ block }: BlockProps<VanBanBlock>) {
  return <MarkdownContent source={block.noi_dung} />;
}

export function HinhAnh({ block }: BlockProps<HinhAnhBlock>) {
  return (
    <figure style={{ margin: 0 }}>
      <Image
        src={block.anh}
        alt={block.chu_thich || block.tieu_de || ""}
        style={{ maxWidth: "100%" }}
      />
      {block.chu_thich && (
        <figcaption style={{ marginTop: 6, color: "#8c8c8c", fontSize: 13 }}>
          {block.chu_thich}
        </figcaption>
      )}
    </figure>
  );
}

export function Doc({ block }: BlockProps<DocBlock>) {
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {block.the.map((t, i) => (
        <div key={i}>
          {t.tieu_de && <Text strong>{t.tieu_de}</Text>}
          <Paragraph style={{ margin: "4px 0 0" }}>{t.noi_dung}</Paragraph>
        </div>
      ))}
    </Space>
  );
}

/** Trắc nghiệm nhanh trong bài — phản hồi ngay, KHÔNG tính điểm môn (điểm đi qua Quiz). */
export function TracNghiem({ block }: BlockProps<TracNghiemBlock>) {
  const [pick, setPick] = useState<Record<number, number>>({});
  return (
    <Space direction="vertical" size="middle" style={{ width: "100%" }}>
      {block.cau.map((q, i) => {
        const p = pick[i];
        const answered = p !== undefined;
        return (
          <div key={i}>
            <Flex align="center" gap={8} wrap>
              <Text strong>
                {i + 1}. {q.hoi}
              </Text>
              {q.audio && <AudioButton src={q.audio} />}
              {q.chu_lon && <span style={{ fontFamily: HAN_FONT, fontSize: 26 }}>{q.chu_lon}</span>}
            </Flex>
            <Radio.Group
              value={p}
              onChange={(e) => setPick({ ...pick, [i]: e.target.value as number })}
              style={{ marginTop: 6 }}
            >
              <Space direction="vertical">
                {q.lua_chon.map((o, j) => (
                  <Radio key={j} value={j}>
                    <span style={{ fontFamily: HAN_FONT }}>{o}</span>
                  </Radio>
                ))}
              </Space>
            </Radio.Group>
            {answered && (
              <Alert
                style={{ marginTop: 8 }}
                type={p === q.dap_an ? "success" : "error"}
                showIcon
                message={p === q.dap_an ? "Đúng" : "Chưa đúng"}
                description={
                  <div>
                    {q.hien && (
                      <div style={{ marginBottom: 4 }}>
                        <WordLine w={q.hien} size={20} />
                      </div>
                    )}
                    {q.giai_thich}
                  </div>
                }
              />
            )}
          </div>
        );
      })}
    </Space>
  );
}

export function TheTu({ block }: BlockProps<TheTuBlock>) {
  return (
    <Flex wrap gap={12}>
      {block.tu.map((w, i) => (
        <Card key={i} size="small" style={{ width: 200 }}>
          <Flex align="flex-start" justify="space-between" gap={8}>
            <WordLine w={w} size={26} />
            <AudioButton src={w.audio} label={`Nghe ${w.chu}`} />
          </Flex>
          {w.nghia && <div style={{ marginTop: 6 }}>{w.nghia}</div>}
          {w.tu_loai && <Tag style={{ marginTop: 6 }}>{w.tu_loai}</Tag>}
        </Card>
      ))}
    </Flex>
  );
}
